import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, withStyles } from '@material-ui/core';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark
    }
});
const ApiKeyDelete = props => {
    let { classes, deleteModalState, entityName, translations, handleCloseSafe, deleting, handleCloseDanger } = props;

    return (
        <Dialog
            open={deleteModalState.open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{translations['bulk_delete'] || 'Bulk delete'} {entityName}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {translations['carefully_deleting_something'] || 'Be careful when deleting something.'}<br />
                    {translations['sure_want_delete'] || `Are you sure you want to delete `} {translations['these'] || 'these'} {` ${entityName}`} {translations['data'] || 'data'}?
        </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" disabled={deleting} className={classes.buttonSafe}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={handleCloseDanger} variant="contained" disabled={deleting} className={classes.buttonDanger}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(ApiKeyDelete);